module.exports = __webpack_public_path__ + "img/report-icon.596f9eb8.svg";